import { styled } from "@mui/system"
import { Box, Typography } from "@mui/material"

export const InvoiceDetailPageLayout = styled(Box)({
  display: "grid",
  gridTemplateColumns: "320px 1fr",
  maxHeight: "100%",
  gridTemplateRows: "64px 56px 1fr",
  gap: "0px 0px",
  gridTemplateAreas:
    '"overall-nav overall-nav" "sidebar invoice-nav" "sidebar widget-box"',
  flex: 1,
})

export const InvoiceBarWrapper = styled(Box)({
  gridArea: "overall-nav",
})

export const SidebarWrapper = styled(Box)({
  gridArea: "sidebar",
  overflowX: "scroll",
})

export const InvoiceNavWrapper = styled(Box)({
  gridArea: "invoice-nav",
})
export const WidgetBoxWrapper = styled(Box)({
  gridArea: "widget-box",
  overflowX: "scroll",
  background: "var(--background-off-white)",
})

export const AttachmentWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  width: "100%",
  paddingBottom: "30px",
})

export const InnerWrapper = styled(Box)({
  marginLeft: "32px",
  marginRight: "32px",
})

export const ContentTitle = styled(Typography)({
  color: "var(--brand-text-default)",
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: "0.15px",
  flex: "1 0 0",
})

export const WidgetHeader = styled(Typography)({
  display: "flex",
  paddingTop: "12px",
  alignItems: "center",
  gap: "4px",
  alignSelf: "stretch",
})
